import React, { useState } from 'react';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styles from './RecentSales.module.css';
import VisSensor from '../VisSensor/VisSensor'

const RecentSales = () => {

  const [isVis, setIsVisible] = useState(false);

  const onChange = (isVisible) => {
    if(isVis === false && isVisible === true) {
      setIsVisible(true);
    }
  }

  const data = useStaticQuery(graphql`
    query  {

      car1: file(relativePath: { eq: "recent-sales/car1.png" }) {
        childImageSharp {
          fluid(maxWidth: 286) {
            ...GatsbyImageSharpFluid
          }
        }
      }
  
      car2: file(relativePath: { eq: "recent-sales/car2.png" }) {
        childImageSharp {
          fluid(maxWidth: 286) {
            ...GatsbyImageSharpFluid
          }
        }
      }
  
      car3: file(relativePath: { eq: "recent-sales/car3.png" }) {
        childImageSharp {
          fluid(maxWidth: 286) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      car4: file(relativePath: { eq: "recent-sales/car4.png" }) {
        childImageSharp {
          fluid(maxWidth: 286) {
            ...GatsbyImageSharpFluid
          }
        }
      }
     
    }
    `);
    return (
      <VisSensor watchDiv="wrap" onChange={onChange}>
        <div id="wrap" className={styles.wrapper}>
          <h5 className={styles.recent_title}>Recent<br/> sales</h5>
          <div className={`${styles.car_container} ${!isVis && styles.b1_start} ${isVis && styles.b1_animation}`}>
              <div className={styles.car_name}><p>2018<br/>Audi<br/>S3</p></div>
              <Img className={styles.img} fluid={data.car1.childImageSharp.fluid} />
          </div>
          <div className={`${styles.car_container} ${!isVis && styles.b2_start} ${isVis && styles.b2_animation}`}>
              <div className={styles.car_name}><p>2017<br/>Porsche<br/>Macan<br/>Turbo</p></div>
              <Img fluid={data.car2.childImageSharp.fluid} />
          </div>
          <div className={`${styles.car_container} ${!isVis && styles.b3_start} ${isVis && styles.b3_animation}`}>
              <div className={styles.car_name}><p>2019<br/>BMW<br/>M850i</p></div>
              <Img fluid={data.car3.childImageSharp.fluid} />
          </div>
          <div className={`${styles.car_container} ${!isVis && styles.b4_start} ${isVis && styles.b4_animation}`}>
              <div className={styles.car_name}><p>2011<br/>Porsche<br/>Cayman</p></div>
              <Img fluid={data.car4.childImageSharp.fluid} />
          </div >
        </div>
      </VisSensor>
      )
  
  }

  export default RecentSales
  



